import { createSelector } from "reselect"
import { get, compact } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeDatasetEntitlementsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

const getRawTokenPermissions = (_, props) => get(props, "tokenPermissions.token.resourcePermissions")
const getRawResources = (_, props) => get(props, "resources.resources")

export const getTokenPermissions = createSelector(
  [getRawTokenPermissions],
  (rawTokenPermissions) => compact(rawTokenPermissions),
)

export const getResources = createSelector(
  [getRawResources],
  (rawResources) => compact(rawResources),
)

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro],
  computeDatasetEntitlementsTabs,
)
